import React, { useEffect, useState, useRef } from 'react'
import './Resources.css'
import TeamHeader from "../TeamHeader/TeamHeader";
import FilterDropdown from "../TeamPortalUtil/FilterDropdown";

// Icons
import { LuDownload } from "react-icons/lu";
import { RiNotionFill } from "react-icons/ri";

// Interface
export interface MarketingAsset {
    id: string;
    title: string;
    description: string;
    category: string;
    industry: string;
    url: string;
    digitalUrl: string;
    digitalName: string;
    printUrl: string;
    printName: string;
}


const Resources = () => {

    // Variables
    const [assets, setAssets] = useState<MarketingAsset[]>([])
    const [loadingWhitePapers, setLoadingWhitePapers] = useState(true);

    // -------- Industry Filter --------
    const availableIndustries = ["Utility", "Wildfire", "Other"];
    const [selectedIndustries, setSelectedIndustries] = useState<string[]>([]);

    // Fetching White Papers from notion
    const fetchMarketingAssets = async () => {
        try {
            setLoadingWhitePapers(true);
            const response = await fetch(
                "/api/notion/block-children/28c3634fc8d98066b728ca624dba46e5/",
                {
                    credentials: "same-origin",
                }
            )

            const data = await response.json()

            if (!response.ok) {
                console.error(
                    "Failed to load marketing assets:",
                    data?.error || response.statusText
                )
                return
            }

            const dbBlock = data.blocks?.find(
                (block: any) => block.type === "child_database"
            )

            if (!dbBlock?.rows) {
                console.warn("No child database found in Notion response")
                return
            }

            const formattedRows: MarketingAsset[] = dbBlock.rows.map((row: any) => {
                const props = row.properties

                return {
                    id: row.id,

                    title: props.Title?.title?.[0]?.plain_text || "",

                    description:
                        props.Description?.rich_text?.[0]?.plain_text || "",

                    category: props.Category?.select?.name || "",

                    industry: props.Industry?.select?.name || "",

                    url: props.URL?.url || "",

                    digitalUrl:
                        props["Digital Version"]?.files?.[0]?.file?.url || "",

                    digitalName:
                        props["Digital Version"]?.files?.[0]?.name || "",

                    printUrl:
                        props["Print Version"]?.files?.[0]?.file?.url || "",

                    printName:
                        props["Print Version"]?.files?.[0]?.name || ""
                }
            })

            setAssets(formattedRows)

        } catch (error) {
            console.error("❌ Error fetching marketing assets:", error)
        } finally {
            setLoadingWhitePapers(false);
        }
    }

    useEffect(() => {
        fetchMarketingAssets()
    }, [])

    // Setting colors for tags
    const INDUSTRY_COLORS: Record<string, string> = {
        Utility: "#3F6FD8",
        Wildfire: "#FF6600",
        Other: "#8A94A6",
    };

    /* ----------------------------
        Filter Logic
    -----------------------------*/
    const filteredAssets = assets.filter(asset => {

        // Industry filter
        const industryMatch =
            selectedIndustries.length === 0 ||
            selectedIndustries.includes(asset.industry);

        // Keep whitepaper constraint
        const formatMatch = asset.category === "Whitepaper";

        return industryMatch && formatMatch;
    });




    return (
        <div className="customer-directory-body">
            <TeamHeader title="Marketing" />

            <div className="customer-title-and-expand-buttons">
                <h1 className="cutomer-title with-less-margin">Resources</h1>
            </div>

            {/* FilterDropdown */}
            <FilterDropdown
                dropdownClassName="filter-dropdown"
                sections={[
                    {
                        key: "industries",
                        title: "Industry",
                        options: availableIndustries,
                        type: "checkbox",
                    },
                ]}
                onChange={(filters) => {
                    setSelectedIndustries(filters.industries || []);
                }}
            />


            <div className='marketing-resources-wrapper with-more-margin'>

                <div className='marketing-resources-group'>

                    <div className='marketing-resources-group-title-and-notion'>
                        <h2>White Papers </h2>
                        <a href="https://www.notion.so/Print-Digital-Material-28c3634fc8d98066b728ca624dba46e5" target="_blank" rel="noreferrer">
                            <button>
                                <RiNotionFill />
                            </button>
                        </a>
                    </div>


                    <div className='marketing-resources-widgets'>

                        {loadingWhitePapers
                            ? Array.from({ length: 6 }).map((_, i) => (
                                <div key={i} className="marketing-resource-widget">
                                    <div>
                                        <div className="marketing-skeleton marketing-skeleton-tag" />
                                        <div className="marketing-skeleton marketing-skeleton-title" />
                                        <div className="marketing-skeleton marketing-skeleton-text" />
                                        <div className="marketing-skeleton marketing-skeleton-text short" />
                                    </div>
                                    <div className="marketing-skeleton marketing-skeleton-button" />
                                </div>
                            ))
                            : filteredAssets.map(asset => (
                                <div key={asset.id} className='marketing-resource-widget'>
                                    <div>
                                        <div
                                            className='marketing-resource-industry'
                                            style={{
                                                backgroundColor:
                                                    INDUSTRY_COLORS[asset.industry] || "#8A94A6"
                                            }}
                                        >
                                            {asset.industry}
                                        </div>

                                        <h2>{asset.title}</h2>
                                        <p>{asset.description}</p>
                                    </div>

                                    <div className='marketing-resource-buttons'>

                                        {asset.digitalUrl && (
                                            <a href={asset.digitalUrl} target="_blank" rel="noreferrer">
                                                <button className='confirm-btn mailjet-confirm'>
                                                    <LuDownload /> Digital Version
                                                </button>
                                            </a>
                                        )}

                                        {asset.printUrl && (
                                            <a href={asset.printUrl} target="_blank" rel="noreferrer">
                                                <button className='confirm-btn mailjet-confirm'>
                                                    <LuDownload /> Print Version
                                                </button>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ))}


                    </div>


                </div>

            </div>

        </div>
    )
}

export default Resources